import {
  Controller,
  Get,
  Post,
  Patch,
  Delete,
  Param,
  Body,
  Query,
} from '@nestjs/common';
import { CompaniesService } from './companies.service';
import { CreateCompanyDto, UpdateCompanyDto } from '@crm/dto';
import { ApiResponseInterface } from '@crm/interface';

@Controller('companies')
export class CompaniesController {
  constructor(private readonly companiesService: CompaniesService) {}

  // GET /companies
  @Get()
  async getAll(): Promise<ApiResponseInterface> {
    return this.companiesService.getAll();
  }

  // GET /companies/user/:userId
  @Get('user/:userId')
  async getByUserId(@Param('userId') userId: string): Promise<ApiResponseInterface> {
    return this.companiesService.getByUserId(userId);
  }

  // GET /companies/:id
  @Get(':id')
  async getById(@Param('id') id: string): Promise<ApiResponseInterface> {
    return this.companiesService.getById(id);
  }

  // POST /companies
  @Post()
  async create(@Body() dto: CreateCompanyDto): Promise<ApiResponseInterface> {
    return this.companiesService.create(dto);
  }

  // PATCH /companies
  @Patch()
  async update(@Body() dto: UpdateCompanyDto): Promise<ApiResponseInterface> {
    return this.companiesService.update(dto);
  }

  // DELETE /companies
  @Delete()
  async softDelete(@Body() dto: UpdateCompanyDto): Promise<ApiResponseInterface> {
    return this.companiesService.softDelete(dto);
  }
}